import React, { createContext, useContext, useEffect } from 'react';
import { TripDesign } from './types';
import { getDesign } from './registry';
import { loadFont } from './loadFont';
import { parlorScreen } from './parlor-screen';

const DesignContext = createContext<TripDesign>(parlorScreen);

interface DesignProviderProps {
  designId: string;
  children: React.ReactNode;
}

export function DesignProvider({ designId, children }: DesignProviderProps) {
  const design = getDesign(designId);

  useEffect(() => {
    if (design.typography.displayFontUrl) {
      loadFont(design.typography.displayFontUrl);
    }
  }, [design.typography.displayFontUrl]);

  return (
    <DesignContext.Provider value={design}>
      {children}
    </DesignContext.Provider>
  );
}

export function useDesign(): TripDesign {
  return useContext(DesignContext);
}
